<div class="chart-wrapper">
  <canvas baseChart style="position: relative; width:80vh; height: 400px;"
    [data]="pieChartData"
    [options]="pieChartOptions"
    [plugins]="pieChartPlugins"
    [type]="pieChartType">
  </canvas>
</div>